import { render } from "./SubInsured.vue?vue&type=template&id=a4fa72b2&scoped=true"
import script from "./SubInsured.vue?vue&type=script&lang=ts"
export * from "./SubInsured.vue?vue&type=script&lang=ts"

import "./SubInsured.vue?vue&type=style&index=0&id=a4fa72b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a4fa72b2"

export default script